import React, { Component } from 'react'
import { Accordion, Icon, Grid, Image, Pagination } from 'semantic-ui-react'
import { translate } from "react-i18next";
import moment from 'moment'
import cogoToast from "cogo-toast";
import allAxiosCommonTA from "../../../components/axiosComponent/allAxiosCommonTA";
import PdfAxios from "../../../components/axiosComponent/downloadpdf"


class ExportDownload extends Component {
    state = {
        activeIndex: 0,
        response: [],
        currentPage : 1,
        limit : 10,
        totalPages : 1
    }

    componentDidMount() {
        this.getDownloadableFiles()
    }

    getDownloadableFiles = ()=>{
        allAxiosCommonTA({
            url: `/downloadable/list?entity_type=Order&page_no=${this.state.currentPage}&limit=${this.state.limit}&`,
            method: "get",
        })
            .then((response) => {
                console.log(response, "response")
                if(response.data.status ===1) {
                    this.setState({ response: response.data.resultSet , totalPages : response.data.total_pages})
                }
            })
            .catch((err) => {
                console.log("err", err);
            });
    }
    handleClick = (e, titleProps) => {

        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index
        const entity_type = titleProps?.children[1]
        this.setState({ activeIndex: newIndex })
    }

    downloadFile = (file) => {
        PdfAxios({
            completeURL: `${process.env.REACT_APP_TA_API_URL}/downloadable/download?key=${file}&`,
        })
            .then((res) => {
                console.log(res);
                if (res.data.status == 1) {
                    cogoToast.success("File Downloaded Successfully")
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
    handlePaginationChange = (e, { activePage }) => {
        this.setState({ currentPage: activePage }, () => {
            this.getDownloadableFiles()
        });
      };

    render() {
        console.log(this.state.response, "state")
        const { activeIndex } = this.state

        return (
            <React.Fragment>
                <div id="dispatch_bar">
                    <div className="container-fluid dip_bar">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="d-flex justify-content-between">
                                    <h2 className="page-title">Downloads</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="dispatch_bar">

                    <div className="container-fluid dip_bar">

                        <div className="row">
                            <div className="col-sm-12">
                                <div className="d-flex justify-content-between">
                                    <h2 className="page-title">Orders</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ui Container'>
                    {/* <Accordion fluid styled> */}
                    {/* <Accordion.Title
                            active={activeIndex === 0}
                            index={0}
                            onClick={this.handleClick}
                        >
                            <Icon name='dropdown' />
                            Bookings
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 0}>
                            <p>
                                <table class="ui single line table">
                                    <thead>
                                        <tr>
                                            <th>File Name</th>
                                            <th>Date & Time</th>
                                            <th>Download</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>John Lilki</td>
                                            <td>September 14, 2013</td>
                                            <td><button class="ui circular facebook icon button">
                                                <i class="download icon"></i>
                                            </button></td>

                                        </tr>

                                    </tbody>
                                </table>
                            </p>
                        </Accordion.Content> */}

                    {/* <Accordion.Title
                            active={activeIndex === 1}
                            index={1}
                            onClick={this.handleClick}
                        >
                            <Icon name='dropdown' />
                            Order
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 1}>
                            <p>
                                <table class="ui single line table">
                                    <thead>
                                        <tr>
                                            <th>File Name</th>
                                            <th>Date & Time</th>
                                            <th>Download</th>

                                        </tr>
                                    </thead>
                                    {this.state.response ? <tbody>
                                        <tr>
                                            <td>{this.state.response.file_name}</td>
                                            <td>{moment(this.state.response.created_on).format('MMMM  DD , YYYY')}</td>
                                            <td><button class="ui circular facebook icon button" onClick={() => { this.downloadFile(this.state.response) }}>
                                                <i class="download icon"></i>
                                            </button></td>

                                        </tr>

                                    </tbody> : <tbody>
                                        <tr>
                                            <td>John Lilki</td>
                                            <td>September 14, 2013</td>
                                            <td><button class="ui circular facebook icon button">
                                                <i class="download icon"></i>
                                            </button></td>

                                        </tr>

                                    </tbody>}
                                </table>
                            </p>
                        </Accordion.Content> */}

                    {/* <Accordion.Title
                            active={activeIndex === 2}
                            index={2}
                            onClick={this.handleClick}
                        >
                            <Icon name='dropdown' />
                            Hirememo
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 2}>
                            <p>
                                <table class="ui single line table">
                                    <thead>
                                        <tr>
                                            <th>File Name</th>
                                            <th>Date & Time</th>
                                            <th>Download</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>John Lilki</td>
                                            <td>September 14, 2013</td>
                                            <td><button class="ui circular facebook icon button">
                                                <i class="download icon"></i>
                                            </button></td>

                                        </tr>

                                    </tbody>
                                </table>
                            </p>
                        </Accordion.Content> */}
                    {/* </Accordion> */}

                    <p>
                        <table class="ui table pb-4">
                            <thead>
                                <tr>
                                    <th>File Name</th>
                                    <th>User</th>
                                    <th>Status</th>
                                    <th>Date & Time</th>
                                    <th>Download</th>

                                </tr>
                            </thead>
                            <tbody>
                                {this.state?.response?.map((item) => (<tr>
                                    <td className="fixedLength250">{item?.file_name}</td>
                                    <td className="fixedLength250">{item?.user_details ? item.user_details.realname : "NA"}</td>
                                    <td>{item?.status}</td>
                                    <td>{item?.created_on && moment(item.created_on).format('  DD/MM/YYYY , hh:mm A')}</td>
                                    <td><button class="ui circular facebook icon button" onClick={() => { item?.file_url && this.downloadFile(item?.file_url) }}>
                                        <i class="download icon"></i>
                                    </button></td>

                                </tr>))}

                            </tbody>
                            {/* : <tbody>
                                        <tr>
                                            <td>John Lilki</td>
                                            <td>September 14, 2013</td>
                                            <td><button class="ui circular facebook icon button">
                                                <i class="download icon"></i>
                                            </button></td>

                                        </tr>

                                    </tbody>} */}
                        </table>
                    </p>
                </div>
                <div
                    className="life-cycle w3-white ui pagination menu"
                >
                <Pagination
                    defaultActivePage={this.state.currentPage}
                    firstItem={null}
                    lastItem={null}
                    onPageChange={this.handlePaginationChange}
                    pointing
                    secondary
                    totalPages={this.state.totalPages}
                />
                </div>
            </React.Fragment>
        )
    }
}
export default (translate("exportdownload")(ExportDownload));
